import React from 'react';

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  disabled = false,
  className = '',
  ...props
}) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-graweo-terra hover:bg-graweo-chocolate text-white hover:scale-105',
    secondary: 'bg-graweo-chocolate hover:bg-graweo-olive text-white hover:scale-105',
    outline: 'border-2 border-graweo-sand hover:border-graweo-terra text-graweo-chocolate hover:bg-graweo-sand',
    ghost: 'text-graweo-chocolate hover:bg-graweo-sand',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2.5 text-base',
    lg: 'px-6 py-3 text-lg',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}